export default "__VITE_ASSET__BgXaurcd__ 400w, __VITE_ASSET__BUlV07Qd__ 800w, __VITE_ASSET__DTjls8HZ__ 1024w";